import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'celum-chip-set',
  templateUrl: './chip-set.component.html',
  styleUrls: ['./chip-set.component.scss'],
  imports: [MatChipsModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CelumChipSetComponent {
  @Input() public clearAllButtonText = 'SHARED.CLEAR_ALL';
  @Input() public showClearAll = true;
  @Output() public clearAllClicked = new EventEmitter<true>();
}
